import React from "react";
import axios from "axios";

function UploadPdfModal({
                            isAdmin,
                            adminToken,
                            open,
                            onClose,
                            apiRootUrl,
                            defaultYear,
                            defaultWeek
                        }) {
    const [file, setFile] = React.useState(null);
    const [year, setYear] = React.useState(defaultYear);
    const [week, setWeek] = React.useState(defaultWeek);
    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {
        if (open) {
            setYear(defaultYear);
            setWeek(defaultWeek);
            setFile(null);
        }
    }, [open, defaultYear, defaultWeek]);

    if (!open) return null;

    const handleUpload = async () => {
        if (!isAdmin || !adminToken) {
            alert("You are not authorized to upload PDFs.");
            return;
        }

        if (!file) return alert("Please choose a PDF.");
        if (!year || !week) return alert("Year and week are required.");

        try {
            setLoading(true);

            // Clear New Articles directory
            await axios.post(`${apiRootUrl}/v1/move-processed-files`, null, {
                headers: {
                    Authorization: `Bearer ${adminToken}`
                }
            });

            // Get SAS URL
            const sasResp = await axios.get(`${apiRootUrl}/v1/get-sas-url`, {
                headers: {
                    Authorization: `Bearer ${adminToken}`
                }
            });

            const sasUrl = sasResp?.data?.sasUrl;
            if (!sasUrl) throw new Error("sasUrl missing from API response.");

            const pad2 = (n) => String(n).padStart(2, "0");
            const blobPath = `New Articles/alphalinerweekly-${year}-${pad2(week)}.pdf`;

            const [baseUrl, sasToken] = sasUrl.split("?");
            if (!baseUrl || !sasToken) throw new Error("Invalid sasUrl format.");

            const uploadUrl = `${baseUrl}/${encodeURI(blobPath)}?${sasToken}`;

            // Upload PDF to blob
            await axios.put(uploadUrl, file, {
                headers: {
                    "x-ms-blob-type": "BlockBlob",
                    "Content-Type": "application/pdf"
                }
            });

            // Trigger newsletter pipeline
            await axios.post(`${apiRootUrl}/v1/trigger-newsletter-job`, null, {
                headers: {
                    Authorization: `Bearer ${adminToken}`
                }
            });

            alert("Upload successful! Newsletter job triggered.");
            onClose();

        } catch (err) {
            console.error(err);
            alert(err?.message || "Upload failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay" role="dialog" aria-modal="true">
            <div className="modal-card">

                <div className="modal-header">
                    <h2>Add Alphaliner Weekly Summary</h2>
                </div>

                {/* AUTH WARNING */}
                {!isAdmin && (
                    <div className="admin-warning">
                        You are not authorized to upload PDFs.
                    </div>
                )}

                <div className="modal-body">

                    <div className="modal-row">
                        <label>PDF:</label>
                        <input
                            type="file"
                            accept="application/pdf"
                            onChange={(e) => setFile(e.target.files?.[0] || null)}
                            disabled={!isAdmin}
                        />
                    </div>

                    <div className="modal-row">
                        <label>Year:</label>
                        <input
                            type="number"
                            value={year}
                            onChange={(e) =>
                                setYear(parseInt(e.target.value || "0", 10))
                            }
                            disabled={!isAdmin}
                        />
                    </div>

                    <div className="modal-row">
                        <label>Week:</label>
                        <input
                            type="number"
                            value={week}
                            onChange={(e) =>
                                setWeek(parseInt(e.target.value || "0", 10))
                            }
                            disabled={!isAdmin}
                        />
                    </div>

                    <div className="modal-hint">
                        Upload path:&nbsp;
                        <code>
                            New Articles/alphalinerweekly-{year}-{String(week).padStart(2, "0")}.pdf
                        </code>
                    </div>
                </div>

                <div className="modal-footer">
                    <button
                        onClick={handleUpload}
                        disabled={loading || !file || !isAdmin}
                    >
                        {loading ? "Uploading..." : "Upload"}
                    </button>

                    <button onClick={onClose} disabled={loading}>
                        Cancel
                    </button>
                </div>

            </div>
        </div>
    );
}

export default UploadPdfModal;